import RelationFormModule from "components/Modules/Relations/RelationFormModule"
import { promotionTypeOptions } from "constants/defaultValues/firebase"
import { firestoreObject } from "helpers/Firebase"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import { callFirebaseFunction } from "helpers/Functions"
import { useState } from "react"
import ImageWithActionButtons from "../../../promotions/_tabs/Types/ImageWithActionButtons"
import Viator from "../../../promotions/_tabs/Types/Viator"

const Fields = type => {
  if (type === "ImageWithActionButtons") {
    return ImageWithActionButtons
  }
  if (type === "Viator") {
    return Viator
  }

  return []
}

const PromotionForm = ({ opened, parent, onCancel, defaultValues }) => {
  const [type, setType] = useState()

  return (
    <RelationFormModule
      form={{
        title: "Promotions",
        fields: [
          {
            ID: "CF5E0A4F-BF8D-235464-3654-23452435234",
            Type: "Dropdown",
            Name: "Status",
            Label: "Status",
            Required: true,
            GetSelectionOptions: values => {
              return [
                { Name: "Active", ID: "active" },
                { Name: "Inactive", ID: "inactive" },
                { Name: "Deleted", ID: "deleted" },
                { Name: "Removed", ID: "removed" },
              ]
            },
          },
          {
            ID: "CF5E0A4F-BF8D-235464-3654-0A1DDD1CC4A1",
            Type: "Dropdown",
            Name: "Type",
            Label: "Type",
            GetSelectionOptions: values => {
              return promotionTypeOptions
            },
            updateValue: (values, val) => {
              setType(val)
              return { ...values, Type: val }
            },
          },
          ...Fields(type),
        ],
        fieldsToTranslate: ["Title", "SubTitle", "Description"],
        getDefaultValues: async ({ firebaseUID }) => {
          if (!opened) {
            if (defaultValues) {
              setType(defaultValues.Type)
              return { ...defaultValues }
            }

            return {}
          }

          const data = await getFirestoreDocument({
            path: `Offers/Promotions/DataBase/${opened}`,
          })

          setType(data.Type)

          return data
        },
        onSubmit: async (values, { firebaseUID }) => {
          const AIResponse = await callFirebaseFunction("analyzePromotion", {
            values,
          })
          const AIData = AIResponse.data

          if (AIData?.success) {
            const AIAnalysis = AIData.analysis

            values.Tags = [
              ...(AIAnalysis?.thematicCategories || []),
              ...(AIAnalysis?.tags || []),
            ]

            values.UserTypes = AIAnalysis?.userTypes || [
              "Citizen",
              "Tourist",
              "Nomad",
              "Student",
              "Guest",
            ]
          }

          return await createOrUpdateFirestoreDocument({
            path: `Offers/Promotions/DataBase`,
            values: {
              ...values,
              CampaignID: parent,
              CityID: firebaseUID,
              UpdatedAt: firestoreObject.Timestamp.now(),
            },
          })
        },
        onDelete: async ({ firebaseUID }) => {
          return await createOrUpdateFirestoreDocument({
            path: `Offers/Promotions/DataBase`,
            values: { ID: opened, Status: "Deleted" },
          })
        },
      }}
      onCancel={onCancel}
      ID={opened}
    />
  )
}

export default PromotionForm
